import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';


function ContactTwo() {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        website: '',
        message: '',
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const SERVICE_ID = 'service_da6352w';
        const TEMPLATE_ID = 'template_g276v3d';
        const PUBLIC_KEY = 'hkCOv4iqj-SELjBbr';

        emailjs.send(SERVICE_ID, TEMPLATE_ID, formData, PUBLIC_KEY)
            .then(
                (response) => {
                    console.log('SUCCESS!', response.status, response.text);
                    
                    Swal.fire({
                        title: 'Message Sent!',
                        text: 'Your message has been sent successfully. We will get back to you soon.',
                        icon: 'success',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'OK'
                    });

                    setFormData({
                        name: '',
                        phone: '',
                        email: '',
                        website: '',
                        message: '',
                    });
                },
                (error) => {
                    console.error('FAILED...', error);
                    Swal.fire({
                        title: 'Oops...',
                        text: 'Something went wrong! Please try again later.',
                        icon: 'error',
                        confirmButtonColor: '#d33',
                        confirmButtonText: 'Close'
                    });
                }
            );
    };

    return (
        <div>
            <div className="contact-area contact-bg-1 bg_image tmp-section-gap">
                <div className="container">
                    <div className="row">
                        {/* Left Side Contact Info */}
                        <div className="col-lg-5">
                            <div className="contact-inner">
                                <div className="section-head section-head-one-side text-align-left">
                                    <h2 className="title split-collab">
                                        Get free financial <br />
                                        consultation today
                                    </h2>
                                    <p className="description mt--30">
                                        Expert audit, VAT, and ERP advisory to support your business growth and compliance needs.
                                    </p>
                                </div>
                                <ul className="ft-link ft-link-style-two">
                                    <li>
                                        <div className="single-contact background-transparent">
                                            <div className="icon">
                                                <i className="fa-light fa-phone" />
                                            </div>
                                            <div className="content">
                                                <span>Call Us</span>
                                                <a className="contact-here" href="tel:+97317552383">
                                                    +973 17552393
                                                </a>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="single-contact background-transparent">
                                            <div className="icon">
                                                <i className="fa-solid fa-envelope-open-text" />
                                            </div>
                                            <div className="content">
                                                <span>E-mail</span>
                                                <a className="contact-here" href="mailto:Info@aqauditing.com">
                                                    Info@aqauditing.com
                                                </a>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="single-contact background-transparent">
                                            <div className="icon">
                                                <i className="fa-regular fa-map-location-dot" />
                                            </div>
                                            <div className="content">
                                                <span>Address</span>
                                                <a className="contact-here" href="#">
                                                    Office 109, Building 628, Road 1011, Block 410, Sanabis, Manama, P.O. Box 18569, Kingdom of Bahrain
                                                </a>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                {/* <div className="tmp-tag-list tag-list-one">
                                    <a className="tag-list" href="#">Facebook</a>
                                    <a className="tag-list" href="#">Twitter</a>
                                    <a className="tag-list" href="#">Linkedin</a>
                                    <a className="tag-list" href="#">Skype</a>
                                    <a className="tag-list" href="#">Pinterest</a>
                                </div> */}
                            </div>
                        </div>

                        {/* Right Side Contact Form */}
                        <div className="col-lg-7 mt_md--50 mt_sm--50">
                            <div className="contact-form">
                                <div className="section-head section-head-one-side text-align-left">
                                    <span className="subtitle">GET IN TOUCH</span>
                                    <h2 className="title">Free consultation</h2>
                                </div>
                                <form id="contact-form" onSubmit={handleSubmit}>
                                    <div className="contact-form-wrapper row">
                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <input
                                                    className="input-field"
                                                    name="name"
                                                    placeholder="Name"
                                                    type="text"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <input
                                                    className="input-field"
                                                    name="phone"
                                                    placeholder="Phone"
                                                    type="text"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <input
                                                    className="input-field"
                                                    name="email"
                                                    placeholder="Email"
                                                    type="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <input
                                                    className="input-field"
                                                    name="website"
                                                    placeholder="Website"
                                                    type="text"
                                                    value={formData.website}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <textarea
                                                    className="input-field"
                                                    placeholder="How can we help"
                                                    name="message"
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="form-submit-group">
                                                <p className="check-condition">
                                                    <input
                                                        className="check-box"
                                                        type="checkbox"
                                                        id="terms"
                                                        name="terms"
                                                        required
                                                    />
                                                    <label className="condition" htmlFor="terms">
                                                        I agree to the <span>terms</span> and <span>conditions</span>
                                                    </label>
                                                </p>
                                                <button
                                                    name="submit"
                                                    className="tmp-btn btn-secondary"
                                                    type="submit"
                                                >
                                                    <span className="submit-wrapper">
                                                        <span className="btn-text">Submit Now</span>
                                                        <span className="btn-icon">
                                                            <i className="fa-sharp fa-light fa-arrow-right" />
                                                        </span>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactTwo;
